import { defineStore } from 'pinia'
import axios from 'axios'

export const useDataStore = defineStore('dataStore', {
  state: () => ({
    departments: [],
    dataStructures: {}
  }),
  getters: {
  },
  actions: {
    async loadDepartments () {
      if (this.dataStructures.departments) {
        return this.dataStructures.departments
      } else {
        await this.loadDataStructure('departments')
        this.departments = this.dataStructures.departments
      }
    },
    async loadDataStructure (name) {
      let struct = await axios.get(`/v2/data-structures/${name}`)
      this.dataStructures[name] = struct.data.values
    },
    async loadDataStructures (structures) {
      for (const structure of structures) {
        const res = (await axios.get(`/v2/data-structures/${structure}`)).data
        this.dataStructures[structure] = res.values
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/DataStore.js